"use client";
import { NavBar, type NavBar_T } from "@areahub/ui/marketing/nav-bar/nav-bar";
import { usePathname } from "next/navigation";
import { Fragment, useEffect, useState } from "react";

export interface EnterpriseOrIndividualsNavBarProps {
  enterpriseNav: NavBar_T;
  individualsNav: NavBar_T;
}

export default function GlobalNavBar({
  enterpriseNav,
  individualsNav,
}: EnterpriseOrIndividualsNavBarProps) {
  const pathname = usePathname();
  const [nav, setNav] = useState<NavBar_T>({
    navigation: { links: [], buttons: [] },
  });
  useEffect(() => {
    pathname?.includes("individuals")
      ? setNav(individualsNav)
      : setNav(enterpriseNav);
  }, [pathname]);

  if (nav) {
    return <NavBar navigation={nav.navigation} banner={nav.banner} />;
  }
  return <Fragment></Fragment>;
}
